/**
 * Enum Tính BHXH
 * TVDAT 12.07.2022
 */
export default {
  All: -1,
  IsSocialInsurance: 1,
  NotIsSocialInsurance: 0,
};
